import React, { useState } from 'react';
import { toast } from 'react-hot-toast';
import useHttp from '../hooks/use-http';

export const TabContext = React.createContext({
  tabs: [],
  tabsData: [], // dodato
  addTab: () => {},
  deleteTab: () => {},
  setActive: () => {},
  onPageLoad: () => {},
  setData: () => {},
  onTabChange: () => {},
  activeComponent: null,
  object: {},
});

function TabContextProvider(props) {
  const [tabsArr, setTabsArr] = useState([]);
  const [tabsData, setTabsData] = useState([]); // dodato
  const [activeComponent, setActiveComponent] = useState(null);
  const [object, setObject] = useState({ data: {} });
  const { sendRequest } = useHttp('');

  // ======= funkcija za pracenje aktivnosti korisnika =======
  const pracenjeAktivnosti = (title, akcija) => {
    const config = {
      method: 'POST',
      url: 'PracenjeAktivnosti/belezenje_otvaranja_novog_taba',
      data: {
        idKorProm: +localStorage.idKorisnika,
        vrednost: title,
        opisAkcije: akcija,
      },
    };
    sendRequest(config);
  };

  //= ==== Setovanje aktivnog taba =====
  const setActive = (tab) => {
    setActiveComponent(tab.type);
    localStorage.setItem('active', JSON.stringify(tab.type));
    pracenjeAktivnosti(tab.title, 'Prelazak na tab');
  };

  //= ==== Update podataka po tabovima (cuvanje podataka u kontekstu pri promeni tabova) ==========
  const onTabChange = (tab) => {
    const updatedItems = tabsData.map((el) =>
      el.type === tab.type ? tab : el,
    ); // dodato
    setTabsData(updatedItems);
  };

  //= ==== F-ja za dodavanje taba =====
  const onAddTab = (tab) => {
    setObject(tab);
    localStorage.setItem('auxData', JSON.stringify(tab.data));
    const nijeUNizu =
      tabsArr.filter((el) => el.title === tab.title).length === 0;
    if (nijeUNizu) {
      if (tabsArr.length > 9) {
        toast.error('Maksimalan broj otvorenih tabova je 10.');
        return;
      }
      const newTabsArr = tabsArr.concat(tab);
      localStorage.setItem('tabs', JSON.stringify(newTabsArr));
      setTabsArr(newTabsArr);
      const newTabsData = tabsData.concat(tab); // dodato
      setTabsData(newTabsData); // dodato
      setActiveComponent(tab.type);
    } else {
      // U slucaju da je tab vec otvoren, update podaka
      const updatedItems = tabsData.map((el) =>
        el.type === tab.type ? tab : el,
      ); // dodato
      setTabsData(updatedItems); // dodato
      setActiveComponent(tab.type);
    }
    localStorage.setItem('active', JSON.stringify(tab.type));
    pracenjeAktivnosti(tab.title, 'Dodat tab');
  };

  //= ==== F-ja za brisanje taba =====
  const onDeleteTab = (tab) => {
    if (tab.type === object.type) {
      setObject({});
    }
    const newTabsArr = tabsArr.filter((el) => el.title !== tab.title);
    const newTabsData = tabsData.filter((el) => el.title !== tab.title); // dodato
    let index = tabsArr.findIndex((el) => el.type === tab.type);
    if (activeComponent === tab.type) {
      if (newTabsArr[index] === undefined) {
        index = newTabsArr.length - 1;
      }
      localStorage.setItem('active', JSON.stringify(newTabsArr[index].type));
      setActiveComponent(newTabsArr[index].type);
    }
    localStorage.setItem('tabs', JSON.stringify(newTabsArr));
    setTabsArr(newTabsArr);
    setTabsData(newTabsData); // dodato
    pracenjeAktivnosti(tab.title, 'Obrisan tab');
  };

  //= ==== F-ja za proveru da li u LocalStorage postoji niz TAB, ako ima onda setuje vrednost. Omogucava da se ne izgubi niz na reload strane =====
  const onPageLoad = () => {
    let tabs = JSON.parse(localStorage.getItem('tabs'));
    const active = JSON.parse(localStorage.getItem('active'));
    const idFirme = +localStorage.getItem('idFirme');
    let activeTab = 0;
    if (
      Array.isArray(tabs) === false ||
      (Array.isArray(tabs) && tabs.length === 0) ||
      tabs[0].title === undefined ||
      tabs[0].type === undefined
    ) {
      if (idFirme === 1) {
        tabs = [
          { title: 'Pregled klijenata', type: 1070, icon: 'fas fa-users' },
        ];
        activeTab = 1070;
      } else {
        tabs = [{ title: 'Oprema', type: 68, icon: 'fas fa-cogs' }];
        activeTab = 68;
      }
    }
    // prilikom dolaska sa login strane setuje se i otvara se prvi tab home page
    if (
      localStorage.getItem('active') === null ||
      localStorage.getItem('active') === undefined
    ) {
      localStorage.setItem('active', JSON.stringify(activeTab));
      setActiveComponent(activeTab);
    }
    setTabsArr(tabs);
    setTabsData(tabs); // dodato
    localStorage.setItem('tabs', JSON.stringify(tabs));
    if (active) {
      setActiveComponent(active);
    }
  };

  const setData = (data) => {
    setTabsArr(data.tabs);
    setActiveComponent(data.active);
    localStorage.setItem('active', JSON.stringify(data.active));
  };

  return (
    <TabContext.Provider
      value={{
        tabs: tabsArr,
        tabsData,
        addTab: onAddTab,
        deleteTab: onDeleteTab,
        setActive,
        activeComponent,
        onPageLoad,
        setData,
        object,
        onTabChange,
      }}
    >
      {props.children}
    </TabContext.Provider>
  );
}

export default TabContextProvider;
